import { createAsyncThunk } from "@reduxjs/toolkit";

import { TeamMemberStatus, type TeamMemberWithUser } from "@fitness-app/data-models/entities/TeamMember";

import { type AsyncThunkCreator } from "../../../index";
import { TEAM_REDUCER_NAME } from "../types";

type Payload = boolean | void;

export const fetchTeamMembers = createAsyncThunk<TeamMemberWithUser[], Payload, AsyncThunkCreator<string>>(
  `${TEAM_REDUCER_NAME}/fetchTeamMembers`,
  async (_isHeadCoach, { rejectWithValue, extra: { db } }) => {
    const query = db
      .from("team_member")
      .select(
        "*, user:userId(firstName, lastName, avatarUrl), assignedTrainees:trainee(id), assignedTrainers:team_member_assigned!team_member_assigned_headCoachId_fkey(trainer:assignedTrainerId(firstName, lastName, email, id, status, user:userId(avatarUrl, id)))",
      )
      // Usunięci zostają w tabeli dla autorstwa, ale na listach zespołu ich nie ma.
      .neq("status", TeamMemberStatus.DELETED)
      .order("createdAt", { ascending: false });

    const { data, error } = await query.returns<TeamMemberWithUser[]>();

    if (error) {
      return rejectWithValue(error.message);
    }

    return data;
  },
);
